import React from 'react';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';
import { useTranslation } from 'react-i18next';

const CHECKOUT_URL = 'https://buy.stripe.com/bJe4gzbUc70J8OR5Xq0oM04';

const ZendeskOcr = () => {
  const { events } = useGoogleAnalytics();
  const { t, i18n } = useTranslation();

  const handleGetGuideClick = () => {
    events.buyZendeskOcr(i18n.language, 'zendesk_ocr_page');
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-16 w-full">
      <div className="bg-surface rounded-xl border border-line p-8 md:p-12 lg:p-16 text-center w-full">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
          {t('zendesk_ocr.title')}
        </h1>
        <h2 className="text-xl md:text-2xl font-medium text-white/50 mb-8">
          {t('zendesk_ocr.subtitle')}
        </h2>
        <p className="text-lg md:text-xl text-white/70 mb-12 text-left whitespace-pre-wrap leading-relaxed max-w-5xl mx-auto">
          {t('zendesk_ocr.description')}
        </p>
        <button
          onClick={handleGetGuideClick}
          className="bg-cta hover:bg-cta-hover text-ink font-bold py-4 px-12 md:px-16 rounded-lg shadow-md transition duration-300 ease-in-out transform hover:-translate-y-1 text-lg md:text-xl mb-16"
        >
          {t('zendesk_ocr.get_guide_button')}
        </button>

        <div className="w-full flex justify-center mb-12">
          <img
            src="/ocr_zendesk_image.png"
            alt={t('zendesk_ocr.image_alt')}
            loading="lazy"
            className="w-full h-auto rounded-lg shadow-lg border border-line"
          />
        </div>

        <p className="mt-8 text-white/50 text-sm md:text-base border-t border-line pt-8">
          {t('zendesk_ocr.contact_text')}{' '}
          <a href="mailto:contacto@easyappforz.com" className="text-accent-400 font-semibold hover:underline">
            contacto@easyappforz.com
          </a>
        </p>
      </div>
    </div>
  );
};

export default ZendeskOcr;
